import { useEffect, useState } from 'react';
import { fetchTenantInfo } from '../api/tenantApi';
import { useAuth } from '../contexts/AuthContext';

export function useTenantName() {
    const { tenantId, fullName } = useAuth();
    const [tenantName, setTenantName] = useState<string>('Tenant Portal');

    useEffect(() => {
        let cancelled = false;
        async function loadTenant() {
            try {
                const info = await fetchTenantInfo();
                if (!cancelled && info?.name) {
                    setTenantName(info.name);
                }
            } catch {
                if (!cancelled && fullName) {
                    setTenantName(fullName);
                }
            }
        }

        if (tenantId) {
            loadTenant();
        }

        return () => {
            cancelled = true;
        };
    }, [tenantId, fullName]);

    return tenantName;
}
